module.exports = __webpack_public_path__ + "static/WireWheel-6d37546e023301b064c4a190ded1cd08.jpg";